<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row style="align-items: center">
        <v-col>
          <h3>Usuários</h3>
        </v-col>
        <v-col class="text-right">
          <v-btn @click="changeEditMode()" v-permission="'user'" color="blue-grey lighten-1" depressed dark>
            <v-icon>mdi-plus</v-icon> Adicionar
          </v-btn>
        </v-col>
        <v-col cols="2">
          <TheSellerSelect :sellers="sellers" v-model="sellerFilter" />
        </v-col>
        <v-col cols="2">
          <TheSearchInput v-model="search" />
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-5 mb-5 elevation-hb">
      <v-data-table :headers="headers" :items="userFilters" :search="search" :loading="loading">
        <template v-slot:[`item.sellers`]="{ item }">
          <div v-for="(seller, i) in item.sellers" :key="i" style="display: inline">
            <v-chip label v-if="i === 0" color="blue darken-1" dark>{{ seller }}</v-chip>
            <v-chip label v-if="i === 1" color="gray" class="ml-2">+{{ item.sellers.length - 1 }}</v-chip>
          </div>
        </template>

        <template v-slot:[`item.date`]="{ item }">{{ item.expirationDt | formatDate }}</template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip label="Editar Usuário">
            <v-icon class="ma-1" v-permission="'user'" @click="editUser(item)">
              mdi-pencil
            </v-icon>
          </TheToolTip>
          <TheToolTip label="Editar Senha">
            <v-icon class="ma-1" @click="editUserPassword(item)" v-permission="'user'">
              mdi-account-edit
            </v-icon>
          </TheToolTip>
          <TheToolTip label="Apagar Usuário">
            <v-icon class="ma-1" @click="deleteUser(item)" v-permission="'user'">
              mdi-delete
            </v-icon>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog :title="formTitle" v-model="dialog" :dialog="dialog" icon="mdi-user">
      <template>
        <v-form ref="form" v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  v-model="user.idUser"
                  label="ID do usuário"
                  :disabled="editing"
                  :rules="rules.name"
                  :counter="100"
                  color="primary"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  v-model="user.descUser"
                  label="Nome"
                  hint="O nome completo do usuário"
                  color="primary"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field outlined v-model="user.emailUser" label="Email" :rules="rules.email" color="primary" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="user.expiration_dt"
                      label="Data de Expiração"
                      clearable
                      :rules="rules.date"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="user.expiration_dt" no-title @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  v-if="!editing"
                  v-model.lazy="user.appkey"
                  :rules="[(v) => (!!v && v) === match || 'Valores não correspondem']"
                  label="Password"
                  type="password"
                  color="primary"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  v-if="!editing"
                  v-model.lazy="match"
                  label="Confirm Password"
                  type="password"
                  color="primary"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="user.groups"
                  :items="groups"
                  item-text="descGrp"
                  item-value="idGrp"
                  label="Grupos de acesso"
                  color="primary"
                  multiple
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="user.sellers"
                  :items="sellers"
                  item-text="sellerDescription"
                  item-value="sellerId"
                  label="Sellers Vinculados"
                  color="primary"
                  multiple
                  outlined
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0" label color="teal" dark>
                      <span>{{ item.sellerDescription }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ user.sellers.length - 1 }})</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-btn color="primary text--white" depressed @click="reset">Limpar</v-btn>
        <div class="flex-grow-1"></div>
        <v-btn color="primary text--white" :disabled="!valid" depressed @click="saveUser" v-show="editing == false">Salvar</v-btn>
        <v-btn color="primary text--white" :disabled="!valid" depressed @click="saveEditedUser" v-show="editing">Alterar</v-btn>
      </template>
    </TheDialog>

    <TheDialog :title="'Trocar Senha de ' + user.descUser" v-model="dialogPassword" :dialog="dialogPassword" icon="mdi-user">
      <template>
        <v-form ref="form">
          <v-container>
            <v-text-field
              outlined
              v-model="userPassword.appkey"
              label="Nova senha"
              :counter="100"
              color="primary"
              required
              :error="error"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-text-field
              outlined
              v-model="userPassword.passwordConfirm"
              label="Confirmar nova senha"
              :counter="100"
              color="primary"
              :error="error"
              required
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-container>
        </v-form>
      </template>
      <template v-slot:actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary text--white" depressed @click="updatePassword()">Alterar</v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

import TheDialog from '@/components/TheDialog'
import TheToolTip from '@/components/TheToolTip'
import TheSearchInput from '@/components/TheSearchInput'
import TheSellerSelect from '@/components/TheSellerSelect'

export default {
  name: 'Users',
  components: {
    TheDialog,
    TheToolTip,
    TheSearchInput,
    TheSellerSelect,
  },
  computed: {
    formTitle() {
      return this.editing == false ? 'Adicionar Usuário' : 'Editar Usuário'
    },
    userFilters() {
      const users = this.filterUser()
      this.toggleSellerFilter()
      return users
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    dialogPassword: false,
    dialogMessages: false,
    valid: false,
    match: null,
    menu: false,
    search: '',
    editing: false,
    user: {},
    users: [],
    groups: [],
    sellers: [],
    sellerFilter: [],
    headers: [
      { text: 'ID', value: 'idUser' },
      { text: 'Name', value: 'descUser' },
      { text: 'E-mail', value: 'emailUser' },
      { text: 'Sellers', value: 'sellers' },
      // { text: 'Expiração', value: 'date' },
      { text: 'Ações', value: 'action', sortable: false },
    ],
    rules: {
      name: [
        (v) => !!v || 'ID é obrigatório!',
        (v) => (v && v.length <= 100) || 'ID não pode ter mais de 100 caracteres!',
        (v) => /^[a-z0-9]+\.*[a-z0-9]*$/.test(v) || 'Apenas letras minúsculas números e "." são permitidos no ID',
      ],
      email: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'],
    },
    userPassword: {},
    error: false,
    showPassword: false,
  }),
  watch: {
    match: 'validateField',
  },
  methods: {
    loadUsers() {
      this.loading = true
      const url = `${baseApiUrl}/user`
      axios
        .get(url)
        .then((res) => {
          this.users = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    loadGroups() {
      const url = `${baseApiUrl}/grp`
      axios
        .get(url)
        .then((res) => {
          this.groups = res.data
        })
        .catch(showError)
    },
    loadSellers() {
      const url = `${baseApiUrl}/seller`
      axios
        .get(url)
        .then((res) => {
          this.sellers = res.data
        })
        .catch(showError)
    },
    validateField() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    changeEditMode() {
      this.user = {}
      this.editing = false
      this.dialog = true
    },
    saveUser() {
      const url = `${baseApiUrl}/user`
      axios
        .post(url, this.user)
        .then(() => {
          this.loadUsers()
          this.editing = false
          this.dialog = false
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    saveEditedUser() {
      const url = `${baseApiUrl}/user/${this.user.idUser}`
      axios
        .put(url, this.user)
        .then(() => {
          this.loadUsers()
          this.editing = false
          this.dialog = false
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    editUser(user) {
      this.editing = true
      this.user = Object.assign({}, user)
      this.dialog = true
    },
    editUserPassword(user) {
      this.user = Object.assign({}, user)
      this.dialogPassword = true
    },
    deleteUser(user) {
      const url = `${baseApiUrl}/user/${user.idUser}`
      if (confirm('Tem certeza que deseja desabilitar este usuário?')) {
        axios
          .delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadUsers()
          })
          .catch(showError)
      }
    },
    updatePassword() {
      this.error = false
      if (!this.userPassword.appkey || !this.userPassword.passwordConfirm) {
        this.error = true
        return false
      }
      if (this.userPassword.appkey !== this.userPassword.passwordConfirm) {
        this.error = true
        return false
      }
      delete this.userPassword.passwordConfirm

      this.user.appkey = this.userPassword.appkey
      const url = `${baseApiUrl}/user/${this.user.idUser}`
      axios
        .put(url, this.user)
        .then(() => {
          this.dialogPassword = false
          this.userPassword = {}
          delete this.user.appkey
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    filterUser() {
      if (this.sellerFilter.length === 0) {
        return this.users
      }
      let temp = []
      this.users.map((element) => {
        element.sellers.forEach((userSeller) => {
          this.sellerFilter.forEach((fil) => {
            if (fil === userSeller && !temp.includes(element)) {
              temp.push(element)
            }
          })
        })
      })
      return temp
    },
    toggleSellerFilter(sellerFilter) {
      if (sellerFilter) {
        this.sellerFilter = sellerFilter
      }
    },
    openSlaMessageDialog() {
      this.dialogMessages = true
    },
  },
  async mounted() {
    await Promise.all([this.loadUsers(), this.loadGroups(), this.loadSellers()])
  },
}
</script>

<style scopped>
.lista {
  list-style: none;
}
</style>
